
export const getHeadingConfig = (headingPosition: string) => {
  return {
    position: headingPosition,
    buttonPosition: headingPosition === 'right' ? 'left' : 'right'
  };
};


export const positionMap: Record<string, string> = {
  left: 'justify-start text-left',
  center: 'justify-center text-center',
  right: 'justify-end text-right',
};